import Button from '@/features/ui/buttons/components/Button'
import { ButtonProps } from '@/features/ui/buttons/components/Button/types'
import { FC } from 'react'
import { StyleSheet } from 'react-native'

const AccountActionButton: FC<ButtonProps> = ({ textStyle, ...props }) => (
    <Button {...props} textStyle={[styles.label, textStyle]} />
)

const styles = StyleSheet.create({
    label: {
        textTransform: 'uppercase',
        textAlign: 'center',
        flexShrink: 1,
    },
})

export default AccountActionButton
